import React from 'react';

export default class FourOFour extends React.Component {
  render() {
    return <h1>You are on wrong page!</h1>;
  }
}
